import { render, staticRenderFns } from "./RequestAccessToUnit.vue?vue&type=template&id=6b316f90&scoped=true&"
import script from "./RequestAccessToUnit.vue?vue&type=script&lang=ts&"
export * from "./RequestAccessToUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b316f90",
  null
  
)

export default component.exports